export function deviceList
    (state = [], action: any) {
    switch (action.type) {
        case 'DEVICE_LIST':
            return action.data;
        default:
            return state;
    }
}

export function deviceCount
  (state = [], action: any){
    switch (action.type){
      case 'DEVICE_COUNT':
        return action.data;
      default:
        return state;
    }
  }

export function deviceNextToken(state = [], action: any) {
  switch (action.type){
    case 'DEVICE_NEXT_TOKEN':
      return action.data
    default:
      return state
  }
}

export function deviceClearToken(state = [], action: any) {
  switch(action.type){
    case 'DEVICE_CLEAR_TOKEN':
      return action.data
    default:
      return state
  }
}
